const INITIAL_STATE = { list: [], planoList: [], paginaAtual: 0, savingConfig: false, saveConfigError: null, planoCopiaList: [] }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PLANO_FETCHED':
            return { ...state, planoList: action.payload.data }
        case 'PLANOCONTROLADOR_FETCHED':
            return { ...state, list: action.payload.data }
        case 'PLANOUNICO_FETCHED':
            return { ...state, listUnico: action.payload.data }
        case 'PLANOCODIGO_FETCHED':
            return { ...state, listCod: action.payload.data }
        case 'PLANO_PAGE':
            return { ...state, paginaAtual: action.payload }
        case 'PLANO_COPIA_FETCHED':
            return { ...state, planoCopiaList: action.payload.data }
        
        // Casos para o novo fluxo de salvar configuração
        case 'PLANO_CONFIG_SAVE_START':
            return { ...state, savingConfig: true, saveConfigError: null }
        case 'PLANO_CONFIG_SAVE_SUCCESS':
            // Ao salvar com sucesso, podemos querer limpar a planoList local, pois ela foi persistida.
            // Ou forçar um reload da lista do banco de dados através de outra action.
            // Por ora, apenas resetamos o estado de salvamento.
            return { ...state, savingConfig: false, saveConfigError: null, list: [], salvarDB: false } // Limpa a lista local e desativa salvarDB
        case 'PLANO_CONFIG_SAVE_ERROR':
            return { ...state, savingConfig: false, saveConfigError: action.payload }

        default:
            return state
    }
}